/*eslint new-cap:0 */
import _ from 'underscore';
import ko from 'knockout';
import Backbone from 'backbone';
import template from '@bingads-webui-campaign-legacy/crud-keywords/template/section-wrapper.pug';
import CreateView from '@bingads-webui-campaign-legacy/crud-keywords/view/create';
import KeywordPlannerView from '@bingads-webui-campaign-legacy/crud-adgroup/view/keywordPlanner';
import ViewModel from '@bingads-webui-campaign-legacy/crud-keywords/viewmodel/section-wrapper';
import { isCampaignApiError } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import * as LocationTargetTypes from '@bingads-webui-campaign-legacy/location-targets/util/locationTargetTypes';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.showOnlyKeywords = this.options.showOnlyKeywords || false;
    this.popupIds = _.defaults({}, this.options.popupIds, {
      'AdGroupName': 'pop_BA_CampaignCreate_Keywords_AdGroupName',
    });
    this.isSignUp = this.options.scenario === 'signup';

    this.viewmodel = new ViewModel({
      Name: this.isSignUp ? `${i18n.getString('Entity_Adgroup')} 1` : '',
    });
    this.createView = new CreateView(options);
    this.keywordPlannerView = new KeywordPlannerView({
      mode: 'keywordsOnly',
      scenario: options.scenario,
      popupIds: this.options.popupIds,
      activityLogger: options.activityLogger,
    });

    this.keywordPlannerView.on({
      'addKeyword': (newKeyword, sourceReqId) => {
        this.createView.addSuggestion([newKeyword], sourceReqId);
      },
    });
  }

  render() {
    this.$el.html(template({
      i18n,
      isSignUp: this.isSignUp,
      showOnlyKeywords: this.showOnlyKeywords,
      popupIds: this.popupIds,
    }));
    ko.applyBindings(this.viewmodel, this.el);

    this.createView.render();
    this.$('.parser').append(this.createView.el);
    this.createView.parser.isAfterFirstInteraction(false);
    this.keywordPlannerView.render();
    this.$('.keyword-planner-container').append(this.keywordPlannerView.el);

    this.createView.on('keywords:updated', () => {
      this.trigger('keywords:updated');
    });

    this.createView.on('keywords:outTextArea', () => {
      this.trigger('keywords:outTextArea');
    });

    this.createView.on('keywords:addSuggestion', () => {
      this.trigger('keywords:addSuggestion');
    });

    this.createView.on('seedKeywordsEntered', (seedKeywords) => {
      if (_.isArray(seedKeywords) && _.size(seedKeywords) > 0 && this.createView.parser.isKeywordsValid()) {
        this.keywordPlannerView.onSearch({
          keywords: seedKeywords,
        });
      }
    });

    return this;
  }

  logActivity(message) {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(message, this.options.scenario);
    }
  }

  onLanguageLocationChanged(showKeywordPlanner, locations, language) {
    this.viewmodel.showKeywordPlanner(showKeywordPlanner);

    const includedLocations = _.filter(locations, (location) => location.SelectionStatus === LocationTargetTypes.Included);
    const includedCriterions = _.map(includedLocations, (location) => location.Criterion.LocationCriterion || location.Criterion.RadiusCriterion);

    if (language) {
      this.keywordPlannerView.setLanguages(_.isArray(language) ? language : [language]);
    }
    this.keywordPlannerView.setLocationTargeting(includedCriterions);

    // only trigger keyword planner search when we need it (when it shows)
    if (showKeywordPlanner) {
      this.keywordPlannerView.onSearch();
    }
  }

  onAdsUrlUpdated(url) {
    this.keywordPlannerView.onSearch({url});
  }

  clearApiErrors() {
    this.viewmodel.errors.clear(isCampaignApiError);
    this.createView.clearErrors();
  }

  validateViewModel() {
    if (this.showOnlyKeywords) {
      return true;
    }

    const isValid = this.viewmodel.validate();

    if (!isValid) {
      _.each(this.viewmodel.fields, (field) => {
        if (!this.viewmodel[field].isValid()) {
          this.logActivity(`ad group field invalid: ${field}`);
        }
      });
    }

    return isValid;
  }

  validate() {
    return _.every([
      this.createView.validate(),
      this.validateViewModel(),
    ]);
  }

  updateViewModels({keywords, campaignId, adGroupId, hasErrors}) {
    return this.createView.updateViewModels({keywords, campaignId, adGroupId, hasErrors});
  }

  hasChanges() {
    return this.createView.hasChanges;
  }

  getValues(adGroupName, campaignName, adGroupId) {
    const keywords = this.createView.getChangedKeywords({
      Id: adGroupId || 0,
      Name: adGroupName,
    });

    return {
      Keywords: _.map(keywords, (keyword) => {
        return _.defaults({}, keyword, { CampaignName: campaignName } );
      }),
    };
  }

  getCurKeywords() {
    return this.createView.getCurKeywords();
  }

  getAdGroup(adGroupId) {
    const adgroup = {
      Name: this.viewmodel.Name(),
      Medium: 'Search',
      PricingModel: 'CPC',
    };

    if (adGroupId) {
      adgroup.Id = adGroupId;
    }

    return adgroup;
  }

  adGroupNameChange() {
    this.logActivity('crud keywords adgroup name change.');
  }

  get events() {
    return {
      'change input.name': 'adGroupNameChange',
    };
  }
}
